import { driver } from "driver.js";
import "driver.js/dist/driver.css";
import "./mobileHomeTour.css";

/**
 * Product tour — trang chủ mobile /m/home (dashboard tổng quan theo module).
 */
export function startMobileHomeTour() {
  const segments = [
    {
      selector: '[data-tour="m-home-greeting"]',
      title: "Lời chào & ngày",
      description:
        "Hiển thị tên bạn và ngày hiện tại — điểm vào nhanh sau khi đăng nhập trên điện thoại.",
      side: "bottom",
    },
    {
      selector: '[data-tour="m-home-attendance"]',
      title: "Trạng thái chấm công",
      description:
        "Xem nhanh bạn có thể chấm công hay không. Bấm để mở màn chấm công.",
      side: "bottom",
    },
    {
      selector: '[data-tour="m-home-notifications"]',
      title: "Thông báo",
      description: "Số thông báo chưa đọc — bấm để mở hộp thư hệ thống.",
      side: "bottom",
    },
    {
      selector: '[data-tour="m-home-modules"]',
      title: "Báo cáo theo module",
      description:
        "Chỉ hiện nhóm module bạn có quyền xem Dashboard (CRM, HRM, E-Learning, Tài chính). Mỗi khối có chỉ số nhanh và nút Chi tiết vào hub.",
      side: "bottom",
    },
    {
      selector: '[data-tour="m-home-crm"]',
      title: "CRM",
      description:
        "Khách hàng, follow-up, hợp đồng và liên hệ trong tháng — theo phạm vi phân quyền.",
      side: "bottom",
    },
    {
      selector: '[data-tour="m-home-hrm"]',
      title: "HRM",
      description: "Chấm công, tăng ca, nghỉ/công tác và nhân sự trong tháng.",
      side: "bottom",
    },
    {
      selector: '[data-tour="m-home-elearning"]',
      title: "E-Learning",
      description: "Học viên, lớp, khóa học và tỉ lệ điểm danh.",
      side: "bottom",
    },
    {
      selector: '[data-tour="m-home-finance"]',
      title: "Tài chính",
      description: "Chờ duyệt, thực thu, chi đã duyệt và tạm ứng hoàn tất.",
      side: "bottom",
    },
  ];

  const steps = [
    {
      popover: {
        title: "Hướng dẫn nhanh",
        description:
          "Tổng quan tổng hợp báo cáo từng nhóm module theo quyền Dashboard của bạn. Chấm công & thông báo nằm phía trên để thao tác nhanh.",
        side: "over",
        align: "center",
      },
    },
  ];

  for (const seg of segments) {
    const el = document.querySelector(seg.selector);
    if (!el) continue;
    steps.push({
      element: el,
      popover: {
        title: seg.title,
        description: seg.description,
        side: seg.side,
      },
    });
  }

  if (steps.length <= 1) {
    window.alert(
      "Chưa tải đủ giao diện để chạy hướng dẫn. Hãy tải lại trang và thử lại."
    );
    return;
  }

  const d = driver({
    showProgress: true,
    smoothScroll: true,
    nextBtnText: "Tiếp",
    prevBtnText: "Lùi",
    doneBtnText: "Xong",
    popoverClass: "ima-mobile-home-tour",
    steps,
  });

  d.drive();
}
